





























































































































































import Vue from "vue";
import storeHelper from "../../store/store-helper";
import Tasks from "@/store/modules/tasks/tasks";
import { Task, TaskGroup } from "@/tasks";
import Utils from "@/utils";
import TasksList from "../tasks/TasksList.vue";
import { TaskFilterOption, TaskSortOption, TaskListType } from "@/enums";
import TaskFilter from "../tasks/TasksFilter.vue";
import ZenyaDialog from "@/components/dialogs/ZenyaDialog.vue";
import TeamTask from "@/views/Teams/TeamTask.vue";
import { Member } from "@/teams";

export default Vue.extend({
    name: "TasksTab",
    components: { TasksList, TaskFilter, ZenyaDialog, TeamTask },
    props: {
        value: Array as () => Task[],
        isBusy: Boolean,
        teamID: String,
        teamMembers: Array as () => Member[],
        filter: String as () => TaskFilterOption
    },
    data: () => {
        return {
            search: "",
            sort: TaskSortOption.Created,
            taskFilterDrawer: false,
            filteredTasks: [] as Task[],
            selectedFilter: TaskFilterOption.My,
            taskgroups: [] as TaskGroup[],
            currentPortalId: 0,
            showAddTeamTaskDialog: false,
            bus: new Vue()
        };
    },
    created() {
        if (this.mode == "user") document.title = Utils.getPageTitle(`${this.$t("portal.buttons.myTasks")}`, "before");

        this.setFilterOption();
    },
    updated() {
        //Make sure we set on scroll event everytime when updated is called
        this.bus?.$emit("set-on-scroll-event");
    },
    computed: {
        mode(): "user" | "team" {
            return this.teamID ? "team" : "user";
        },
        mdAndDownView(): boolean {
            return this.$vuetify.breakpoint.mdAndDown;
        },
        sortOptions(): string[] {
            const options: Array<string> = [TaskSortOption.Created, TaskSortOption.Deadline, TaskSortOption.Important];
            return options;
        },
        hasTasks(): boolean {
            return this.value.length > 0;
        }
    },
    watch: {
        filter() {
            this.setFilterOption();
        },
        value: {
            deep: true,
            handler(): void {
                if (!this.value || this.value.length == 0) this.filteredTasks = [];
            }
        },
        sort() {
            switch (this.sort) {
                case TaskSortOption.Deadline:
                    this.sortTasksOnDeadline();
                    break;
                case TaskSortOption.Important:
                    this.sortTasksOnImportant();
                    break;
                default:
                    this.sortTaskOnLastModified();
                    break;
            }
        }
    },
    methods: {
        sortTasksOnDeadline(): void {
            this.filteredTasks.sort(
                (a, b) =>
                    (a.deadline_date_time && b.deadline_date_time
                        ? (a.deadline_date_time.getTime() === b.deadline_date_time.getTime()
                              ? a.last_modified_date_time < b.last_modified_date_time
                                  ? 1
                                  : -1
                              : 0) || (a.deadline_date_time > b.deadline_date_time ? 1 : -1)
                        : 0) ||
                    (a.deadline_date_time ? -1 : 0) ||
                    (b.deadline_date_time ? 1 : 0) ||
                    (a.last_modified_date_time.getTime() === b.last_modified_date_time.getTime()
                        ? 0
                        : a.last_modified_date_time < b.last_modified_date_time
                        ? 1
                        : -1)
            );
        },
        sortTasksOnImportant(): void {
            this.filteredTasks.sort(
                (a, b) =>
                    (a.is_important && b.is_important
                        ? a.is_important === b.is_important
                            ? a.last_modified_date_time < b.last_modified_date_time
                                ? 1
                                : -1
                            : 0
                        : 0) ||
                    (a.is_important ? -1 : 0) ||
                    (b.is_important ? 1 : 0) ||
                    (a.last_modified_date_time.getTime() === b.last_modified_date_time.getTime()
                        ? 0
                        : a.last_modified_date_time < b.last_modified_date_time
                        ? 1
                        : -1) ||
                    (a.deadline_date_time && b.deadline_date_time
                        ? a.deadline_date_time.getTime() === b.deadline_date_time.getTime()
                            ? 0
                            : a.deadline_date_time < b.deadline_date_time
                            ? 1
                            : -1
                        : 0)
            );
        },
        sortTaskOnLastModified(): void {
            this.filteredTasks.sort(
                (a, b) =>
                    (a.last_modified_date_time.getTime() === b.last_modified_date_time.getTime()
                        ? 0
                        : a.last_modified_date_time < b.last_modified_date_time
                        ? 1
                        : -1) ||
                    (a.deadline_date_time && b.deadline_date_time
                        ? a.deadline_date_time.getTime() === b.deadline_date_time.getTime()
                            ? 0
                            : a.deadline_date_time < b.deadline_date_time
                            ? 1
                            : -1
                        : 0)
            );
        },
        setFilterOption() {
            if (this.filter) {
                //Set filter from query string
                if (this.filter == TaskFilterOption.My || this.filter == TaskFilterOption.NotAssigned || this.filter == TaskFilterOption.Postponed)
                    this.selectedFilter = this.filter;

                //Remove the filter query string
                if (this.$route.query.filter) this.$router.replace({ query: null });
            }
        }
    }
});
